import {
  BarsOutlined,
  CameraOutlined,
  DownOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  LinkOutlined,
  ReloadOutlined,
  SaveOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import {
  Button,
  Col,
  Divider,
  Dropdown,
  Form,
  Input,
  message,
  Radio,
  Row,
  Space,
  Tabs,
  Tag,
} from 'antd';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_STATUS_ENUM } from '../../../../../../common/enums/enums';
import KoganError from '../../../../errors/KoganError';
import { extractTaskIdFromPendingUrl, handleKoganResponse } from '../../../../utils/koganUtils';
import {
  checkAsyncStatus,
  createProducts,
  updateProducts,
} from '../../../productmanagement/services/kogan-products-service';
import { getFileUrlsInFolder } from '../../slices/productImagesSlice';
import { getProductStatus, selectById, updateStatus } from '../../slices/tabProductsSlice';
import { TAB_TYPE_ENUM } from '../../slices/tabsSlice';
import DescriptionFeaturesTab from './DescriptionFeaturesTab';
import ImagesTab from './ImagesTab';
import ProductInfoTab from './ProductInfoTab';
const { TextArea } = Input;

function AddUpdateProductFormContainer({ productId, type }) {
  const [selectedSourceType, setSelectedSourceType] = useState(
    type === TAB_TYPE_ENUM.EDIT ? CARD_TYPE_ENUM.KOGAN : CARD_TYPE_ENUM.S3
  );

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const product = useSelector((state) => selectById(state, productId));
  let asyncStatus = useSelector((state) =>
    getProductStatus(state, productId)
  );
  const images = useSelector((state) => getFileUrlsInFolder(state, productId));
  useEffect(() => {
    //if there is no loading status present, and we are running component in edit mode, then do a fetch.
    if (
      asyncStatus &&
      asyncStatus.status === FETCH_STATUS_ENUM.SUCCESS.status
    ) {
      form.setFieldsValue(createInitialValues());
    }
  },[product]);
  const onFinish = (values) => {
    dispatch(updateStatus({ product_sku: productId, status: FETCH_STATUS_ENUM.SAVING }));
    form.getFieldsValue();
    const p = {
      brand: values.brand,
      category: `ebay:${values.category.value}`,
      enabled: values.enabled,
      product_title: values.product_title,
      product_sku: values.product_sku,
      product_description: values.product_description,
      product_inbox: values.product_inbox,
      product_subtitle: values.product_subtitle,
      product_gtin: values.product_gtin,
      stock: values.stock,
      offer_data: {
        AUD: {
          price: values.price,
          shipping: values.shipByWeight===true?null: values.shipByWeight!==true && values.shipping === null ? 0 : values.shipping,
          handling_days: values.handling_days,
          rrp: values.rrp,
          kogan_first_price: values.kogan_first_price,
        },
      },
      product_dimensions: {
        length: values.length,
        width: values.width,
        height: values.height,
        weight: values.weight,
      }
    };
   
    if (type === TAB_TYPE_ENUM.EDIT) {
      if (selectedSourceType.source === CARD_TYPE_ENUM.S3.source) {
        p.images = images;
      } else {
        p.images = product.images;
      }
      updateProducts({ products: [p] }, false)
        .then((resp) => {
         handleKoganResponse(resp,productId,message,dispatch);
        })
        .catch((error) => {
          message.error(<KoganError error={error} />, 10);
        });
    } else {
      p.images = images;
      createProducts({ products: [p] })
        .then((resp) => {
          handleKoganResponse(resp,productId,message,dispatch);
        })
        .catch((error) => {
          message.error(<KoganError error={error} />, 10);
        });
    }
  };

  const createInitialValues = () => {
    if (type === TAB_TYPE_ENUM.NEW) {
      return { product_sku: productId };
    } else {
      // const category = <Select.Option label={product.category_slug}  value={product.category} >{product.category_slug}</Select.Option>;
      const category = {
        value: product.category,
        label: product.category_slug,
      };
      return {
        ...product,
        price: product.offer_data.AUD.price,
        kogan_first_price: product.offer_data.AUD.kogan_first_price,
        rrp: product.offer_data.AUD.rrp,
        shipping: product.offer_data.AUD.shipping,
        handling_days: product.offer_data.AUD.handling_days,
        category,
        length: product.product_dimensions?.length,
        width: product.product_dimensions?.width,
        height: product.product_dimensions?.height,
        weight: product.product_dimensions?.weight,
        shipByWeight: product.offer_data.AUD.shipping===null?true:false
      };
    }
  };
  const initialValues = {
    ...createInitialValues(),
    product_location: 'AU',
    product_condition: 'new',
    product_multipack: 1,
  };

  const onStoreUrlsChange = (e) => {
    window.open(e.target.value, '_blank');
  };
  const getStoreUrls = () => {
    return (
      product?.store_urls && (
        <Radio.Group
          size="middle"
          onChange={onStoreUrlsChange}
          buttonStyle={'solid'}
        >
          {product.store_urls.map((store, idx) => {
            return (
              <Radio.Button value={store.url} key={idx}>
                {' '}
                <LinkOutlined /> {store.organisation}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      )
    );
  };

  const storeUrls = useMemo(() => getStoreUrls(), [product?.store_urls]);
 const getStatusTag = () => {
  if(asyncStatus?.status === FETCH_STATUS_ENUM.SUCCESS.status){
    return <Tag color={FETCH_STATUS_ENUM.SUCCESS.color}>{FETCH_STATUS_ENUM.SUCCESS.displayName}</Tag>
  }else if(asyncStatus?.status === FETCH_STATUS_ENUM.FAILED.status){
    return <Tag color={FETCH_STATUS_ENUM.FAILED.color}>{FETCH_STATUS_ENUM.FAILED.displayName}</Tag>
  }else if(asyncStatus?.status === FETCH_STATUS_ENUM.LOADING.status){
    return <Tag color={FETCH_STATUS_ENUM.LOADING.color} icon={<SyncOutlined spin />}>{FETCH_STATUS_ENUM.LOADING.displayName}</Tag>
  } else if(asyncStatus?.status === FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.status){
    return <Tag color={FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.color}>{FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.displayName}</Tag>
  } else if(asyncStatus?.status === FETCH_STATUS_ENUM.KOGAN_COMPLETE_WITH_ERRORS.status){
    return <Tag color={FETCH_STATUS_ENUM.KOGAN_COMPLETE_WITH_ERRORS.color}>{FETCH_STATUS_ENUM.KOGAN_COMPLETE_WITH_ERRORS.displayName}</Tag>
  }else if(asyncStatus?.status === FETCH_STATUS_ENUM.KOGAN_COMPLETE.status){
    return <Tag color={FETCH_STATUS_ENUM.KOGAN_COMPLETE.color}>{FETCH_STATUS_ENUM.KOGAN_COMPLETE.displayName}</Tag>
  }else if(asyncStatus?.status === FETCH_STATUS_ENUM.KOGAN_FAILED.status){
    return <Tag color={FETCH_STATUS_ENUM.KOGAN_FAILED.color}>{FETCH_STATUS_ENUM.KOGAN_FAILED.displayName}</Tag>
  } else if(asyncStatus?.status === FETCH_STATUS_ENUM.GENERIC_ERROR.status){
    return <Tag color={FETCH_STATUS_ENUM.GENERIC_ERROR.color}>{FETCH_STATUS_ENUM.GENERIC_ERROR.displayName}</Tag>
  } else if(asyncStatus?.status === FETCH_STATUS_ENUM.SAVING.status){
    return <Tag color={FETCH_STATUS_ENUM.SAVING.color} icon={<SyncOutlined spin />}>{FETCH_STATUS_ENUM.SAVING.displayName}</Tag>
  } else if(!asyncStatus){
    return <Tag>UNSAVED</Tag>
  }
 };
 const statusTag = useMemo(() => getStatusTag(), [asyncStatus?.status]);

 const checkPendingStatus = () => {
  if(asyncStatus?.status === FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.status){
    dispatch(updateStatus({ product_sku: productId, status: FETCH_STATUS_ENUM.LOADING }));
    const taskId = extractTaskIdFromPendingUrl(asyncStatus.url);
     checkAsyncStatus(taskId).then((res) => {
      handleKoganResponse(res,productId,message,dispatch);

     }).catch((error) => {
        message.error(<KoganError error={error} />, 10);
     });

  }
 };

  return (
    <Row gutter={24}>
      <Col span={24}>
        {contextHolder}
        <Form
          colon={false}
          form={form}
          layout="vertical"
          name="stockPriceUpdate"
          //   labelCol={{ span: 10 }}
          //   wrapperCol={{ span: 16 }}
          initialValues={initialValues}
          onFinish={onFinish}
        >
          <Row gutter={24} justify={'center'}>
            <Col span={11}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  ghost
                  disabled={asyncStatus?.status === FETCH_STATUS_ENUM.SAVING.status || asyncStatus?.status === FETCH_STATUS_ENUM.LOADING.status  }
                >
                  Save to Kogan
                </Button>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button icon={<ReloadOutlined />} disabled={!asyncStatus || asyncStatus?.status !== FETCH_STATUS_ENUM.KOGAN_ASYNCRESPONSEPENDING.status} onClick={checkPendingStatus}>
                Check Status
              </Button>
            </Col>
            <Col span={6}>{type === TAB_TYPE_ENUM.EDIT && storeUrls}</Col>
            <Col span={4}>
              {type === TAB_TYPE_ENUM.EDIT &&
                `Created On: ${moment(product.created).format('lll')}`}
                {statusTag}
            </Col>
          </Row>
          <Tabs defaultActiveKey="productInfoTab">
            <Tabs.TabPane
              key="productInfoTab"
              tab={
                <span>
                  <FileTextOutlined />
                  Product Info
                </span>
              }
            >
              <ProductInfoTab form={form} />
            </Tabs.TabPane>
            <Tabs.TabPane
              forceRender={true}
              tab={
                <span>
                  <BarsOutlined />
                  Description & Features
                </span>
              }
              key="descFeaturesTab"
            >
              <DescriptionFeaturesTab  form={form} />
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={
                <span>
                  <CameraOutlined />
                  Images
                </span>
              }
              key="imagesTab"
            >
              {/* <Row gutter={[24,24]} justify={'start'} style={ { overflow: 'auto'}}>
                  {getCards()}
                </Row>
                <Divider>Upload Area</Divider> */}
              <ImagesTab
                productId={productId}
                selectedSourceType={selectedSourceType}
                setSelectedSourceType={setSelectedSourceType}
              />
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </Col>
    </Row>
  );
}

export default AddUpdateProductFormContainer;
export const CARD_TYPE_ENUM = {
  KOGAN: {
    source: 'kogan',
    title: 'Kogan Images',
  },
  S3: {
    source: 's3',
    title: 'S3 Images',
  },
};
